var _DeviceSizes;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var BaseSizes = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  '2xl': '2xl',
  '3xl': '3xl',
  '4xl': '4xl'
};

export var DeviceSizes = (_DeviceSizes = {}, _defineProperty(_DeviceSizes, BaseSizes.sm, BaseSizes.sm), _defineProperty(_DeviceSizes, BaseSizes.md, BaseSizes.md), _defineProperty(_DeviceSizes, BaseSizes.lg, BaseSizes.lg), _defineProperty(_DeviceSizes, BaseSizes.xl, BaseSizes.xl), _DeviceSizes);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/styles/sizes.js
// module id = 37
// module chunks = 0